module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-cracha-personalizado.14d64621.jpg";